var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0C5.59635 0 0 5.59635 0 12.5C0 19.4036 5.59635 25 12.5 25C19.4036 25 25 19.4036 25 12.5C25 5.59635 19.4036 0 12.5 0ZM9.4401 17.681H6.90885V9.53516H9.4401V17.681ZM8.15885 8.53516C7.35937 8.53516 6.84245 7.96875 6.84245 7.26823C6.84245 6.55338 7.375 6.00391 8.19141 6.00391C9.00781 6.00391 9.50781 6.55338 9.52344 7.26823C9.52344 7.96875 9.00781 8.53516 8.15885 8.53516ZM18.6849 17.681H16.1536V13.1667C16.1536 12.1159 15.7865 11.4023 14.8711 11.4023C14.1719 11.4023 13.7565 11.8854 13.5729 12.3503C13.5052 12.5156 13.4883 12.75 13.4883 12.9831V17.6797H10.9557V12.1328C10.9557 11.1159 10.9232 10.2656 10.8893 9.53385H13.0885L13.2044 10.6654H13.2552C13.5885 10.1341 14.4049 9.35026 15.7708 9.35026C17.4362 9.35026 18.6849 10.4661 18.6849 12.8646V17.681Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkedin);
export default __webpack_public_path__ + "static/media/icon-linkedin.bfc3eda732864167351d6110dbd74504.svg";
export { ForwardRef as ReactComponent };